<template>
  <NewAccountErrorTemplate
    :title="title"
    :subtitle="subtitle"
    :onClose="onClose"
  />
</template>

<script>
import NewAccountErrorTemplate from "@/views/profile/components/NewAccountErrorTemplate";

const TITLE = "This role has been cancelled";
const SUBTITLE =
  "You are no longer able to apply for this role as it has been cancelled";

export default {
  name: "ApplicationInvalid",
  components: {
    NewAccountErrorTemplate
  },
  data() {
    return {
      title: TITLE,
      subtitle: SUBTITLE
    };
  },
  methods: {
    onClose() {
      this.$router.push("/applications");
    }
  }
};
</script>
